import { z } from 'zod';

import { PERMISSION_KEYS } from './types';

/** Mirrors apps/api/src/modules/identity/http/staff.dto.ts's `inviteStaffSchema` exactly. */
export const inviteStaffFormSchema = z.object({
  email: z.string().trim().toLowerCase().min(3).max(254).email('Adresse email invalide.'),
  permissions: z.array(z.enum(PERMISSION_KEYS)).max(PERMISSION_KEYS.length).default([]),
});
export type InviteStaffFormValues = z.infer<typeof inviteStaffFormSchema>;

/** Mirrors `updateStaffSchema` — permissions only (this UI never changes `status` through the same form; see StaffTable's dedicated suspend/reactivate action). */
export const updatePermissionsFormSchema = z.object({
  permissions: z.array(z.enum(PERMISSION_KEYS)).max(PERMISSION_KEYS.length),
});
export type UpdatePermissionsFormValues = z.infer<typeof updatePermissionsFormSchema>;
